import React from "react";
import { connect } from 'react-redux';
import Select from 'react-select';
import { Actions as COMPANYACTIONS } from '../../../store/actions/companyActions';
import { Actions as LEAVEACTIONS } from '../../../store/actions/leaveActions';
import _ from 'lodash';
import { ArrowDownIcon, PlusIcon, XMarkIcon } from "@heroicons/react/20/solid";

import { v4 as uuidv4 } from 'uuid';

const ruleTypes = [
    { label: "Hours Worked in Period", value: "Hours Worked in Period" },
    { label: "Basic Hours in Period", value: "Basic Hours in Period" },
    { label: "Basic Hours in Month", value: "Basic Hours in Month" },
    { label: "Hours in Period", value: "Hours in Period" },
    { label: "Hours in Month", value: "Hours in Month" },
    { label: "Basic Hours in Week", value: "Basic Hours in Week" },
    { label: "Hours Worked in Week", value: "Hours Worked in Week" },
    { label: "Hours in Week", value: "Hours in Week" },
    { label: "Hours in Day/Shift", value: "Hours in Day/Shift" },
    { label: "Day of Week", value: "Day of Week" },
    { label: "Time of Day", value: "Time of Day" },
    { label: "Start of Shift", value: "Start of Shift" },
    { label: "Is Leave", value: "Is Leave" },
    { label: "Leave Type", value: "Leave Type" },
    { label: "Department", value: "Department" },
    { label: "Location", value: "Location" },
    { label: "Position", value: "Position" },
  
  ]

const ruleConditions = [
    { label: "Larger than", value: "Larger than" },
    { label: "Smaller than", value: "Smaller than" },
    { label: "Larger or equal to", value: "Larger or equal to" },
    { label: "Smaller or equal to", value: "Smaller or equal to" },
    { label: "Equal to", value: "Equal to" },
    { label: "Not equal to", value: "Not equal to" },
    { label: "Contains", value: "Contains" }
  ]
  const ruleContinue = [
    { label: "AND", value: "AND" },
    { label: "OR", value: "OR" }
  ]

const weekDay = [
    { label: "Sunday", value: 0 },
    { label: "Monday", value: 1 },
    { label: "Tuesday", value: 2 },
    { label: "Wednesday", value: 3 },
    { label: "Thursday", value: 4 },
    { label: "Friday", value: 5 },
    { label: "Saturday", value: 6 },
    { label: "Public Holiday", value: "Public Holiday" },
  ]
  
const YesNo = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
  ]
  
const RulePart = ({ 
    index, 
    part, 
    updateRulePart, 
    removeRulePart, 
    addRulePart, 
    addCompositeRulePart, 
    updateRuleCondition, 
    withLabels, 
    condition, 
    departments, 
    leaveTypes, 
    level, 
    disabled 
}) => {

    const updateRulePartHelper = (attribute, value) => {
      console.log('update rule part', attribute, value)
  
      const updatedRulePart = { ...part }
  
      updatedRulePart[attribute] = value;
  
      updateRulePart(index, updatedRulePart);
    }
  
    const updateNestedRulePart = (nestedIndex, rulePart) => {
  
      console.log('rulePart', nestedIndex, rulePart)
  
      const updatedRulePart = { ...part }
  
      part.parts[nestedIndex] = rulePart;
  
      updateRulePart(index, updatedRulePart);
    }
  
    const removeNestedRulePart = (nestedIndex) => {
  
      console.log('rulePart', nestedIndex)
  
      const updatedRulePart = { ...part }
  
      part.parts.splice(nestedIndex, 1)
  
      if (updatedRulePart.parts.length == 0) {
  
        removeRulePart(index)
        return;
      }
  
      updateRulePart(index, updatedRulePart);
    }
  
    const addNestedRulePart = (nestedIndex) => {
  
      console.log('rulePart', nestedIndex)
  
      const updatedRulePart = { ...part }
  
      part.parts.splice(nestedIndex + 1, 0, { id: uuidv4() })
  
      updateRulePart(index, updatedRulePart);
    }
  
    const addNestedCompositeRulePart = (nestedIndex) => {
  
      console.log('rulePart', nestedIndex)
  
      const updatedRulePart = { ...part }
  
      part.parts.splice(nestedIndex + 1, 0,
        {
          id: uuidv4(),
          "condition": condition == 2 ? 3 : 2,
          "parts": [{
            id: uuidv4()
          }]
        }
      )
  
      updateRulePart(index, updatedRulePart);
    }
  
    const updateCondition = (condition) => {
  
      const updatedRulePart = { ...part }
  
      updatedRulePart.condition = condition.value;
  
      updateRulePart(index, updatedRulePart);
    }
  
    if (part.parts) {
      return (
        <React.Fragment>
          {part.parts.map((rulePart, index) => (
            <React.Fragment>
              <RulePart updateRuleCondition={updateCondition} removeRulePart={removeNestedRulePart} addRulePart={addNestedRulePart} addCompositeRulePart={addNestedCompositeRulePart} level={level + 1} part={rulePart} withLabels={false} condition={part.condition} updateRulePart={updateNestedRulePart} index={index} key={rulePart.id} departments={departments} />
              <div className="clearfix" />
            </React.Fragment>
          ))}
        </React.Fragment>
      )
    }
  
    const nestingWidth = `calc(25% - ${level * 20}px)`;
    const leftMargin = `${level * 20}px`;
    const nestingStyle = {
      borderLeft: "solid 1px",
      borderBottom: "solid 1px",
      width: "calc(100% + 20px)",
      marginLeft: `${(parseInt(level) * 20) + 10}px`,
      padding: "10px",
      position: "absolute",
    }
  
    if (level != 0 && index == 0) {
      nestingStyle.marginLeft = "-10px"
      nestingStyle.marginTop = "-28px"
      nestingStyle.padding = "24px"
    }
  
    if (index == 1) {
      nestingStyle.marginTop = "-10px"
      nestingStyle.padding = "14px"
    }
  
    if (index > 1) {
      nestingStyle.marginTop = "-28px"
      nestingStyle.padding = "24px"
    }
  
    const levelFill = {
      position: "absolute",
      left: "25px",
      height: "70px",
      width: "1px",
      background: "black",
      top: "-28px",
    }
  
    console.log(nestingWidth, 'nestingWidth', level, level * 20)
  
    return (
      <div style={{ position: "relative", marginTop: "10px" }}>
  
  
        {index == 0 &&
          <div className="col-xs-3" style={{ width: nestingWidth, marginLeft: leftMargin }}>
            {withLabels && <label>AND/OR</label>}
            <div style={nestingStyle}></div>
            <Select
              id="and-or-dropdown"
              value={_.find(ruleContinue, { value: condition })}
              options={ruleContinue}
              isDisabled={disabled}
              onChange={updateRuleCondition}
            />
            <div className="clearfix" />
          </div>
        }
  
        {
          index !== 0 && level != 0 &&
          <div style={levelFill}></div>
        }
  
        {index !== 0 &&
  
          <div className="col-xs-3" >
            <div style={nestingStyle}></div>
          </div>
  
        }
  
  
        <div className="col-xs-3">
          {withLabels && <label>Where</label>}
          <Select
            id="where-dropdown"
            value={_.find(ruleTypes, { value: part.type })}
            options={ruleTypes}
            isDisabled={disabled}
            onChange={(selectedOption) => {
              updateRulePartHelper('type', selectedOption.value);
            }}
          />
          <div className="clearfix" />
        </div>
        <div className="col-xs-3">
          {withLabels && <label>is</label>}
  
          <Select
            id="is-dropdown"
            value={_.find(ruleConditions, { value: part.condition })}
            options={ruleConditions}
            isDisabled={disabled}
            onChange={(selectedOption) => {
              updateRulePartHelper('condition', selectedOption.value);
            }}
          />
          <div className="clearfix" />
        </div>
  
        <div className="col-xs-3">
          <div className="row" style={{ padding: 0 }}>
            <div className="col-xs-6">
              {withLabels && <label>Value</label>}
  
              {part.type == "Day of Week" &&
  
                <Select
                  value={_.find(weekDay, { value: part.value })}
                  options={weekDay}
                  isDisabled={disabled}
                  onChange={(selectedOption) => {
                    updateRulePartHelper('value', selectedOption.value);
                  }}
                />
              }
  
              {part.type == "Is Leave" &&
  
                <Select
                  value={_.find(YesNo, { value: part.value })}
                  options={YesNo}
                  isDisabled={disabled}
                  onChange={(selectedOption) => {
                    updateRulePartHelper('value', selectedOption.value);
                  }}
                />
              }

              {part.type == "Department" &&
                
                <Select
                  value={_.find(departments, { value: part.value })}
                  options={departments}
                  isDisabled={disabled}
                  onChange={(selectedOption) => {
                    updateRulePartHelper('value', selectedOption.value);
                  }}
                />
              }
  
              {part.type == "Leave Type" &&
                
                <Select
                  value={_.find(leaveTypes, { value: part.value })}
                  options={leaveTypes}
                  isDisabled={disabled}
                  onChange={(selectedOption) => {
                    updateRulePartHelper('value', selectedOption.value);
                  }}
                />
              }
  
              {!["Day of Week", "Department", "Is Leave", "Leave Type"].includes(part.type) &&
                <input
                  style={{ maxWidth: "100%" }}
                  value={part.value}
                  disabled={disabled}
                  placeholder={
                    part.type && (part?.type?.includes?.('in Period') || part?.type?.includes?.('in Month'))
                      ? "Contract based"
                      : ""
                  }
                  onChange={(e) => {
                    updateRulePartHelper('value', e.target.value);
                  }}
                />
              }
              <div className="clearfix" />
            </div>
            {!disabled &&
              <div className="col-xs-6">
                {withLabels && <label>Actions</label>}
                <div
                  id="delete-rule"
                  className="btn btn-xs btn-danger"
                  onClick={
                    () => {
                      removeRulePart(index)
                    }
                  } title="Remove this Rule" style={{ marginRight: "5px", cursor: "pointer" }} >
                  <XMarkIcon style={{ height: "1.1em", float: "left" }} />
                </div>
                <div
                  id="same-level-button"
                  className="btn btn-xs btn-default"
                  onClick={
                    () => {
                      addRulePart(index)
                    }
                  } title="Add another rule at the same level" style={{ marginRight: "5px", cursor: "pointer" }} >
                  <PlusIcon style={{ height: "1.1em", float: "left" }} />
                </div>
                {level == 0 &&
                  <div
                    id="composite-level-button"
                    className="btn btn-xs btn-default"
                    onClick={
                      () => {
                        addCompositeRulePart(index)
                      }
                    } title="Add a new composite rule" >
                    <ArrowDownIcon style={{ height: "1.1em", float: "left" }} />
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
  
    )
  }  

const mapStateToProps = (state) => {

    const allowanceOvertimeOptions = []
  
    state.company?.settings?.overtimes?.map(o => {
      allowanceOvertimeOptions.push({
        value: o.id,
        label: o.name
      })
    })
    state.company?.settings?.allowances?.map(o => {
      allowanceOvertimeOptions.push({
        value: o.id,
        label: o.name
      })
    })
  
    const leaveTypes = state.leave?.leaveTypes?.map(o => {
      return {
        value: o.id,
        label: o.name
      }
    })
  
    return {
      currentOrg: state.company?.settings?.org,
      allowanceOvertimeOptions,
      allowances: state.company?.settings?.allowances,
      overtime: state.company?.settings?.overtimes,
      departments: state.company?.settings?.departments,
      leaveTypes: leaveTypes,
      isDemo: state.company?.settings?.isDemo,
      organisationDetails: state.company?.settings,
      disabled: (state?.permissions?.my?.permissions?.settings == 'Read') || (state?.company?.settings?.status == 'Archived'),
      jurisdiction: state.company?.settings?.jurisdiction,
    }
  }
  
  const mapDispatchToProps = (dispatch) => ({
    updateSetting: (field, newValue) => dispatch(COMPANYACTIONS.updateSetting(field, newValue, false)),
    updateCompanyDetails: (body) => dispatch(COMPANYACTIONS.updateCompanyDetails(body)),
    getLeaveTypes: () => dispatch(LEAVEACTIONS.getLeaveTypes()),
  });
  
  export default connect(mapStateToProps, mapDispatchToProps)(RulePart);
  